declare namespace $ {

	export class $bog_builderui_progress extends $mol_view {
		value( ): number
		max( ): number
		dom_name( ): string
		attr( ): ({ 
			'value': ReturnType< $bog_builderui_progress['value'] >,
			'max': ReturnType< $bog_builderui_progress['max'] >,
		})  & ReturnType< $mol_view['attr'] >
	}
	
}

//# sourceMappingURL=progress.view.tree.d.ts.map